import { GivelifyMenu } from '@givelify/givelify-ui';
import { Menu, styled } from '@mui/material';

const lightBlueColor = '#f8fdff';
const blueColor = '#cce2ef';

export const StyledGivelifyMenu = styled(GivelifyMenu)(({
    '& .menuDropdownOptions': {
        width: 'max-content',
    },
    '& .selectRoot': {
        width: 235,
    },
}));
  
export const NewMenuOptions = styled(Menu)(({ theme }) => ({
    marginTop: 8,
    '&, & .MuiMenu-list': {
        padding: '26px 0',
        [theme.breakpoints.down(768)]: {
        padding: '20px 0',
        },
    },
    '& .Mui-selected': {
        backgroundColor: blueColor,
    },
    '& .MuiListItem-button:hover': {
        backgroundColor: lightBlueColor,
    },
    '& .MuiListItem-button': {
        paddingRight: 50,
    },
}));
  
export const NewUserMenuOptions = styled(NewMenuOptions)(({ theme }) => {
    return {
        '& .MuiPaper-root': {
                minWidth: '400px',
                '@media (max-width:768px)': {
                    minWidth: '186px',
                },
            },
        '& .MuiListItem-button': {
            padding: theme.spacing(2),
        },
    };
});

export const scrollBarStyles = () => ({
    '&::-webkit-scrollbar': {
        width: '8px',
        height: '8px',
    },
    '&::-webkit-scrollbar-track': {
        background: 'transparent',
    },
    '&::-webkit-scrollbar-track-piece:start': {
        background: 'transparent',
    },
    '&::-webkit-scrollbar-track-piece:end': {
        background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
        background: '#cacaca',
        borderRadius: '25px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
        background: '#cacaca',
    },
});

export const MessageContainer = styled('div')(({
    display: 'flex',
    alignItems: 'center',
}));

export const InlineContent = styled('div')(({ theme }) => ({
    backgroundColor: theme.legacy.palette.background.paper,
    display: 'inline-flex',
    alignItems: 'center',
    minHeight: '48px',
    padding: '12px 16px',
    marginLeft: theme.spacing(2),
    borderRadius: theme.spacing(4),
    border: '1px solid #ccc',
    maxWidth: '100%',
    '& .word-break': {
        wordBreak: 'break-word',
    },
    '& .margin-right': {
        marginRight: theme.spacing(2),
    },
    '& *': {
        display: 'inline-block',
    },
    [theme.breakpoints.down('xs')]: {
        display: 'flex',
        flexDirection: 'column',
        rowGap: '8px',
        alignItems: 'start',
    },
}));
